import { render, staticRenderFns } from "./employee-request-snackbar.vue?vue&type=template&id=6cbdeeea"
import script from "./employee-request-snackbar.vue?vue&type=script&lang=js"
export * from "./employee-request-snackbar.vue?vue&type=script&lang=js"
import style0 from "./employee-request-snackbar.vue?vue&type=style&index=0&id=6cbdeeea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports